document.addEventListener('DOMContentLoaded', function () {
gsap.registerPlugin(ScrollTrigger);
if (window.innerWidth >= 750) {
document.querySelectorAll('.hscroll-wrapper').forEach(function (wrapper) {
const track = wrapper.querySelector('.hscroll-track');
if (!track) return;
const getDistance = () => track.scrollWidth - window.innerWidth;
gsap.to(track, {
x: () => -getDistance(),
ease: 'none',
scrollTrigger: {
trigger: wrapper,
start: 'top top',
end: () => '+=' + getDistance(),
scrub: 1,
pin: true,
invalidateOnRefresh: true
}
});
});
}
if (window.innerWidth < 750) {
const items = document.querySelectorAll('.hscroll-item');
if (items.length) {
const observer = new IntersectionObserver(
function (entries) {
entries.forEach(function (entry) {
entry.target.classList.toggle('is-active', entry.isIntersecting);
});
},
{
root: null,
threshold: 0.6
}
);
items.forEach(function (item) { observer.observe(item); });
}
}
});